exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.verti[data-v-57effdd7],\n.horiz[data-v-57effdd7] {\n  position: absolute;\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.verti[data-v-57effdd7] {\n  width: 0;\n  cursor: ew-resize;\n}\n.horiz[data-v-57effdd7] {\n  height: 0;\n  cursor: ns-resize;\n}\n.square[data-v-57effdd7] {\n  width: 10px;\n  height: 10px;\n  border: 1px solid #2196f3;\n  background-color: #fff;\n  flex-shrink: 0;\n}\n", ""]);

// exports
